import { Component, Fragment } from "react";
import utilsExport from "../../../../../utils/utilsExport";
import utils from "../../../utils/utils";

export default class Tabela extends Component {

    constructor(props) {
        super(props);
    }

    defineTitulo = (tipo, tipoConsolidado) => {
        let texto;
        switch(tipo) {
            case 'regimental': texto = 'Gratuidade Regimental'; break
            case 'nao_regimental': texto = 'Gratuidade Não-Regimental'; break
            case 'pago': texto = 'Pagas'; break
        }
        return `Análise ${texto} EP Departamento Regional (Consolidado por ${tipoConsolidado})`
    }

    render() {
        let { realizados, total, tipo, tipoConsolidado } = this.props;
        let matriculaTipo = `matricula_${tipo}`
        let horaTipo = `hora_${tipo}`
        return (
            <Fragment>
                <div className="table-responsive">
                <table border="1" className="table table-bordered table-hover table-sm table-striped text-center">
                    <thead>
                        <tr>
                            <th colSpan="12" className="text-center">{this.defineTitulo(tipo, tipoConsolidado)}</th>
                        </tr>
                        <tr>
                            <th colSpan="1" className="text-center"></th>
                            <th colSpan="3" className="text-center">Matrículas</th>
                            <th colSpan="6" className="text-center">Horas</th>
                        </tr>
                        <tr>
                            <th className="text-center">Modalidade</th>
                            <th>Meta</th>
                            <th>Realizado</th>
                            <th>%</th>
                            <th>Meta</th>
                            <th>Realizado</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            realizados && Object.keys(realizados).map(modalidade => {
                                let meta                     = realizados[modalidade]['meta'];
                                let realizado                = realizados[modalidade]['realizado'];
                                let totalMetaMatriculas      = meta[matriculaTipo]
                                let totalRealizadoMatriculas = realizado[matriculaTipo]
                                let totalMetaHoras           = meta[horaTipo]
                                let totalRealizadoHoras      = realizado[horaTipo]

                                // verifica modalidades com valores zerados para omitir a visualização
                                let valoresZerados = totalMetaMatriculas + totalRealizadoMatriculas + totalMetaHoras + totalRealizadoHoras
                                if(valoresZerados === 0) return;

                                

                                return (
                                    <Fragment>
                                        <tr>
                                            <td className="text-start" style={{ backgroundColor: "#c5c0ad" }}>{tipoConsolidado === 'Unidade' ? utilsExport.retiraCodigoUnidade(modalidade) : modalidade}</td>
                                            <td>{utils.formataNumero(meta[matriculaTipo])}</td>
                                            <td>{utils.formataNumero(realizado[matriculaTipo])}</td>
                                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentualExport(totalMetaMatriculas, totalRealizadoMatriculas, "matricula")}</td>
                                            <td>{utils.formataNumero(meta[horaTipo])}</td>
                                            <td>{utils.formataNumero(realizado[horaTipo])}</td>
                                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentualExport(totalMetaHoras, totalRealizadoHoras, "hora")}</td>
                                        </tr>
                                    </Fragment>
                                )
                            })
                        }
                        <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                            <td className="text-start" style={{ backgroundColor: "#c5c0ad" }}>{'Total'}</td>
                            <td>{utils.formataNumero(total['meta'][matriculaTipo])}</td>
                            <td>{utils.formataNumero(total['realizado'][matriculaTipo])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentualExport(total['meta'][matriculaTipo], total['realizado'][matriculaTipo], "matricula")}</td>
                            <td>{utils.formataNumero(total['meta'][horaTipo])}</td>
                            <td>{utils.formataNumero(total['realizado'][horaTipo])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentualExport(total['meta'][horaTipo], total['realizado'][horaTipo], "hora")}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            </Fragment>
        )
    }

}